export default "__VITE_ASSET__DCCRIK20__"